import api from './api';

export const userService = {
  async getAll() {
    const response = await api.get('/users/registered/');
    return response.data.data || [];
  },

  async getById(id) {
    const response = await api.get(`/users/registered/${id}`);
    return response.data.data;
  },

  async update(id, data) {
    const response = await api.put(`/users/registered/${id}`, data);
    return response.data.data;
  },
};
